var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82596 20.7513C7.81907 23.7268 10.5785 25.9375 13.4808 25.2817V25.2817C14.9006 24.9609 16.0871 23.9916 16.6846 22.6643L20.5876 13.9955C21.7223 11.4753 21.067 8.50909 18.9761 6.70153L18.3378 6.14973C16.8214 4.83876 14.7151 4.233 12.9113 5.10737C8.14645 7.41706 7.81655 11.4923 7.82819 12.695C7.83043 12.9261 7.84355 13.1541 7.84301 13.3852L7.82596 20.7513Z",
    fill: "url(#paint0_linear_536_2981)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.77792C15 6.37079 15.129 6.8989 15.3358 7.36468C16.3521 9.6528 18.3212 11.7413 18.3623 14.2446L18.4514 19.6766C18.5037 22.8601 20.9406 25.4954 24.1102 25.7961L25.3472 25.9135C29.0157 26.2616 32.1875 23.3764 32.1875 19.6914V13.5931C32.1875 1.19908 15 0.839488 15 5.77792Z",
    fill: "url(#paint1_linear_536_2981)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8437 27.5938C10.4375 27.5938 7.6875 30.3437 7.6875 33.75C7.6875 35.0937 7.96875 35.75 10.1562 36.2187C10.1562 36.2187 17.5 37.5 20 37.5C22.5 37.5 29.8438 36.2187 29.8438 36.2187C32.0313 35.75 32.3125 35.125 32.3125 33.75C32.3125 30.3437 29.5625 27.5938 26.1562 27.5938H13.8437Z",
    fill: "url(#paint2_linear_536_2981)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 25V28.375C16.3125 30.4063 17.9687 32.0625 20 32.0625C22.0312 32.0625 23.6875 30.4063 23.6875 28.375V25.0312L16.3125 25Z",
    fill: "url(#paint3_linear_536_2981)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5626 14.0937C31.7188 14.0937 31.9688 19.1563 28.5626 19.2813C28.2501 21.8438 26.7501 27.25 20.0001 27.25C13.2501 27.25 11.7501 21.8438 11.4376 19.2813C8.06255 19.1563 8.12505 14.0937 11.4376 14.0937C11.4376 14.0937 15.3126 13.8125 18.3126 12.3438C18.5626 12.5 20.1563 13.7813 22.5001 14.2813C22.5001 14.2813 21.6563 13 21.6251 12.0312C21.5938 12.0312 25.1876 13.9062 28.5626 14.0937Z",
    fill: "url(#paint4_radial_536_2981)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 16.9062C16.8121 16.9062 17.3437 16.3746 17.3437 15.7187C17.3437 15.0629 16.8121 14.5312 16.1562 14.5312C15.5004 14.5312 14.9688 15.0629 14.9688 15.7187C14.9688 16.3746 15.5004 16.9062 16.1562 16.9062Z",
    fill: "url(#paint5_linear_536_2981)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 16.9062C24.4996 16.9062 25.0312 16.3746 25.0312 15.7187C25.0312 15.0629 24.4996 14.5312 23.8438 14.5312C23.1879 14.5312 22.6562 15.0629 22.6562 15.7187C22.6562 16.3746 23.1879 16.9062 23.8438 16.9062Z",
    fill: "url(#paint6_linear_536_2981)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_2981",
    x1: 7.80818,
    y1: 15.3175,
    x2: 22.5015,
    y2: 15.3175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1639,
    stopColor: "#FC7660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3836,
    stopColor: "#F56756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7524,
    stopColor: "#EB5248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E84B43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_2981",
    x1: 23.5958,
    y1: 26.5384,
    x2: 23.5958,
    y2: 2.81335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7660"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_536_2981",
    x1: 20,
    y1: 37.5,
    x2: 20,
    y2: 27.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CC3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADAFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_536_2981",
    x1: 20,
    y1: 31.6224,
    x2: 20,
    y2: 24.5484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1655,
    stopColor: "#FEB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3534,
    stopColor: "#FCA695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5514,
    stopColor: "#F78F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#F27165"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_536_2981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.61331 10.859) scale(24.31 24.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4411,
    stopColor: "#FFB6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6327,
    stopColor: "#FFAF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#FEA292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8945,
    stopColor: "#FD9082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9978,
    stopColor: "#FC7A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_536_2981",
    x1: 14.5481,
    y1: 14.3139,
    x2: 16.6509,
    y2: 16.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_536_2981",
    x1: 22.2875,
    y1: 14.2408,
    x2: 24.3244,
    y2: 16.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.608a20d95578cc6f22f7a7ec485bd2f0.svg";
export { ForwardRef as ReactComponent };